import { render, staticRenderFns } from "./InvoiceWindow.vue?vue&type=template&id=0008c58c&"
import script from "./InvoiceWindow.vue?vue&type=script&lang=js&"
export * from "./InvoiceWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports